import React from "react";
import {cloneDeep} from "lodash";
import {
    ActionButton,
    IconButton,
    TextField
} from "@fluentui/react";
import Accordion from "../Common/Accordion";

interface IAttributesTableProps {
    title?: string;
    attributes: IAttributeKV[]
    editMode?: boolean;
    onUpdate?: (attributes: IAttributeKV[]) => void;
}

export interface IAttributeKV {
    key: string;
    value: string | number | undefined;
}

export const AttributesTable: React.FC<IAttributesTableProps> = (props) => {
    const updateAttribute = (i: number, key: string, value: string | number | undefined) => {
        if (!props.onUpdate) return;
        const newAttributes = cloneDeep(props.attributes);
        newAttributes[i] = {key, value};
        props.onUpdate(newAttributes);
    }

    const addAttribute = () => {
        if (!props.onUpdate) return;
        const newAttributes = cloneDeep(props.attributes);
        newAttributes.push({key: '', value: undefined});
        props.onUpdate(newAttributes);
    }

    const deleteAttribute = (i: number | undefined) => {
        if (!props.onUpdate) return;
        if (i === undefined) return;
        const newAttributes = cloneDeep(props.attributes);
        newAttributes.splice(i, 1);
        props.onUpdate(newAttributes);
    }

    if (props.attributes.length === 0 && !props.editMode) return null;

    return(
    <Accordion indentWidth={10} useChevron={true} titleComponent={<h3>{props.title}</h3>} beginExpanded={true}>
        <div>
            {(props.attributes && props.attributes.length > 0) && 
            <div className={"ac-attribute-segment"}>
                {props.attributes.map((item, i) => (
                <div key={i} style={{ marginBottom: 12, display: 'flex', flexDirection: 'row' }}>
                    <div style={{minWidth: '100px', width: '25%', paddingRight: '10px'}}>
                        {props.editMode ?
                        <TextField
                            placeholder={`${props.title ?? 'Attribute'} Key`}
                            value={item.key}
                            onChange={(e, d) => {
                                updateAttribute(i, d ?? '', item.value);
                            }}
                        />
                        : <>{item.key}</>}
                    </div>
                    <div style={{minWidth: '100px', width: '25%'}}>
                        {props.editMode ?
                        <TextField
                            placeholder={`${props.title ?? 'Attribute'} Value`}
    
                            value={item.value?.toString()}
                            onChange={(e, d) => {
    
                                if (i !== undefined) {
                                    if (props.title === "Filters") {
                                        const onlyNums = d?.replace(/[^0-9.]/g, '');
                                        updateAttribute(i, item.key, onlyNums);
                                    } else {
                                        updateAttribute(i, item.key, d);
                                    }
                                }
                            }}
                        />
                        : <>{item.value}</>}
                    </div>
                    <div>
                        {props.editMode ? <IconButton
                        iconProps={{iconName: 'Delete'}}
                        onClick={() => deleteAttribute(i)}
                    /> : <></>}
                    </div>
                </div>))}
            </div>}
            <div>
                {props.editMode && <ActionButton
                    iconProps={{iconName: 'Add'}}
                    onClick={() => addAttribute()}
                >{`Add ${props.title}`}</ActionButton>}
            </div>
        </div>
    </Accordion>)
};
